import React, { useEffect } from 'react';
import { Globe, Smartphone, Apple, Settings, Watch, Tv } from 'lucide-react';
import AOS from "aos";
import "aos/dist/aos.css";

const Solve = () => {
  useEffect(() => {
    AOS.init({  
      duration: 1200,
      once: true,
    });
  }, []);

  const platforms = [
    { icon: Globe, title: 'Website', description: 'Mobile-first, cloud-ready products' },
    { icon: Smartphone, title: 'Android', description: 'Advanced analytics & reporting' },
    { icon: Apple, title: 'iOS', description: 'Secure IT infrastructure' },
    { icon: Settings, title: 'Desktop Application', description: 'Secure and high-performance desktop solutions ' },

  ];

  return (
    <div className="relative bg-gray-900 overflow-hidden" id='project-id'>
      {/* Background Image Overlay */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80')`,
        }}
      >
        <div className="absolute inset-0 bg-gray-900 bg-opacity-80"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 py-16 lg:py-24 flex items-center ">
        <div className="w-full text-center">

          {/* Small Tag */}
          <div
            className="inline-flex items-center space-x-2 mb-8"
            data-aos="fade-down"
            data-aos-delay="200"
          >
            <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
            <span className="text-blue-400 font-medium text-sm">What We Solve</span>
          </div>

          {/* Main Heading */}
          <h1
            className="text-4xl md:text-5xl lg:text-6xl xl:text-6xl font-bold text-white leading-tight mb-10"
            data-aos="zoom-in"
            data-aos-delay="400"
          >
            Help You Overcome Your
            <br />
            Technology Challenges
          </h1>

          <h4 className='text-white my-3 mb-10' >
            Every business faces unique challenges—outdated systems, poor integrations, <br /> or lack of automation.
            At Dynamic Softlink, we help you overcome them by
          </h4>

          {/* Platform Icons Grid */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 lg:gap-8 max-w-6xl mx-auto">
            {platforms.map((platform, index) => {
              const IconComponent = platform.icon;
              return (
                <div
                  key={index}
                  data-aos="fade-up"
                  data-aos-delay={200 + index * 150} // staggered animations
                  className="group p-6 lg:p-8 border border-gray-600 rounded-xl bg-gray-800 bg-opacity-50 backdrop-blur-sm hover:bg-opacity-70 hover:border-blue-500 transition-all duration-300 hover:scale-105"
                >
                  <div className="flex flex-col items-center space-y-4">
                    <div className="w-12 h-12 lg:w-16 lg:h-16 flex items-center justify-center">
                      <IconComponent className="w-8 h-8 lg:w-10 lg:h-10 text-blue-400 group-hover:text-blue-300 transition-colors" />
                    </div>
                    <div className="text-center">
                      <h3 className="text-white font-semibold text-lg lg:text-xl mb-1">
                        {platform.title}
                      </h3>
                      <p className="text-gray-400 text-sm hidden lg:block">
                        {platform.description}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Floating Elements */}
      <div className="absolute top-20 left-10 w-4 h-4 bg-blue-500 rounded-full opacity-30 animate-pulse hidden lg:block"></div>
      <div className="absolute bottom-32 right-16 w-6 h-6 bg-blue-400 rounded-full opacity-20 animate-pulse hidden lg:block"></div>
      <div className="absolute top-1/3 right-10 w-3 h-3 bg-white rounded-full opacity-25 animate-pulse hidden lg:block"></div>
    </div>
  );
};

export default Solve;
